<app-toast />
<p-confirmDialog [style]="{ width: '26rem' }"></p-confirmDialog>

<section class="gerenciar-comissoes">
    <app-card-content [border]="false" headingLevel="h1" icon="pi pi-sitemap" title="Gerenciar Comissões" subtitle="Cadastro, membros e histórico de comissões">
        <div card-header>
            @if (estado !== 'insercao') {
                <app-botao-acoes label="Ações" [items]="itensAcoes"></app-botao-acoes>
            }
        </div>

        <div class="flex flex-col gap-5 pb-6">
            @if (semComissaoCarregada) {
                <div class="comissao-vazia" role="status">
                    <i class="pi pi-sitemap comissao-vazia-icone"></i>
                    <p class="comissao-vazia-titulo">Nenhuma comissão selecionada</p>
                    <p class="comissao-vazia-texto">Use <strong>Ações &rsaquo; Localizar</strong> para abrir uma comissão existente, ou <strong>Ações &rsaquo; Novo</strong> para cadastrar uma.</p>
                </div>
            }

            @if (form.codigo) {
                <div class="flex justify-end -mb-3">
                    <span class="badge-status-comissao" [ngClass]="comissaoAtiva ? 'badge-comissao-ativa' : 'badge-comissao-inativa'">
                        <i class="pi" [ngClass]="comissaoAtiva ? 'pi-check-circle' : 'pi-ban'"></i>
                        <span>{{ comissaoAtiva ? 'Comissão Ativa' : 'Comissão Extinta' }}</span>
                    </span>
                </div>
            }

            <!-- ══════════════════════════════════════════
                 CARD 1 — Identificação e Hierarquia
            ══════════════════════════════════════════ -->
            <div class="card-entrada card-entrada-1">
                <app-card-content [icon]="'pi pi-id-card'" [title]="'Identificação e Hierarquia'" [subtitle]="'Dados cadastrais e estrutura organizacional'">
                    <div class="flex flex-col gap-7">
                        <!-- Estrutura Superior -->
                        <div class="flex flex-col gap-4">
                            <div class="secao-divisor">
                                <span class="secao-divisor-icone secao-divisor-icone-neutra"><i class="pi pi-sitemap"></i></span>
                                <span class="secao-divisor-label">Estrutura Superior</span>
                            </div>
                            <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
                                <div class="flex flex-col gap-1.5">
                                    <label class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Código</label>
                                    <input pInputText readonly [(ngModel)]="form.estruturaSuperiorCodigo" />
                                </div>
                                <div class="flex flex-col gap-1.5 md:col-span-3">
                                    <label class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Estrutura</label>
                                    <div class="flex gap-2">
                                        <input pInputText readonly [(ngModel)]="form.estruturaSuperiorDescricao" class="flex-1" />
                                        <button type="button" class="botao-icone" (click)="abrirBuscaSuperior()" [disabled]="estado === 'visualizacao'">
                                            <i class="pi pi-search"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Identificação -->
                        <div class="flex flex-col gap-4">
                            <div class="secao-divisor">
                                <span class="secao-divisor-icone secao-divisor-icone-primaria"><i class="pi pi-id-card"></i></span>
                                <span class="secao-divisor-label">Identificação</span>
                            </div>
                            <div class="grid grid-cols-1 md:grid-cols-12 gap-4">
                                <div class="flex flex-col gap-1.5 md:col-span-2">
                                    <label class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Código</label>
                                    <input pInputText [(ngModel)]="form.codigo" [disabled]="true" />
                                </div>
                                <div class="flex flex-col gap-1.5 md:col-span-5">
                                    <label class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Nome *</label>
                                    <input pInputText [(ngModel)]="form.nome" [disabled]="estado === 'visualizacao'" />
                                </div>
                                <div class="flex flex-col gap-1.5 md:col-span-5">
                                    <label class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Coordenador</label>
                                    <div class="flex gap-2">
                                        <input pInputText readonly [value]="coordenadorNome ? coordenadorNome + ' (' + coordenadorUf + ')' : ''" placeholder="Sem coordenador" class="flex-1" />
                                        <button type="button" class="botao-icone" (click)="abrirBuscaCoordenador()" [disabled]="estado === 'visualizacao'">
                                            <i class="pi pi-search"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </app-card-content>
            </div>

            <!-- ══════════════════════════════════════════
                 CARD 2 — Documentação
            ══════════════════════════════════════════ -->
            <div class="card-entrada card-entrada-2">
                <div class="doc-grid grid grid-cols-1 md:grid-cols-2 gap-5">
                    <!-- ── Portarias ── -->
                    <app-card-content [icon]="'pi pi-file-edit'" [title]="'Portarias'" [subtitle]="'Portarias de criação e extinção'">
                        <div class="flex flex-col flex-1 gap-5">
                            <!-- Criação -->
                            <div class="flex flex-col gap-3 p-4 rounded-xl bg-surface-50 dark:bg-surface-800/50 border border-surface-100 dark:border-surface-700">
                                <div class="flex items-center gap-2">
                                    <i class="pi pi-file text-surface-500 dark:text-surface-400 text-sm"></i>
                                    <span class="text-xs font-bold text-surface-500 dark:text-surface-400 uppercase tracking-widest">Portaria de Criação</span>
                                </div>
                                <div class="grid grid-cols-2 gap-3">
                                    <div class="flex flex-col gap-1.5">
                                        <label class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Data</label>
                                        <p-inputmask mask="99/99/9999" [(ngModel)]="form.portariaCriacaoData" placeholder="dd/mm/aaaa" [disabled]="estado === 'visualizacao'"></p-inputmask>
                                    </div>
                                    <div class="flex flex-col gap-1.5">
                                        <label class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Número</label>
                                        <input pInputText [(ngModel)]="form.portariaCriacaoNumero" [disabled]="estado === 'visualizacao'" />
                                    </div>
                                </div>
                            </div>
                            <!-- Extinção -->
                            <div class="flex flex-col gap-3 p-4 rounded-xl bg-surface-50 dark:bg-surface-800/50 border border-surface-100 dark:border-surface-700">
                                <div class="flex items-center gap-2">
                                    <i class="pi pi-ban text-red-400 text-sm"></i>
                                    <span class="text-xs font-bold text-surface-500 dark:text-surface-400 uppercase tracking-widest">Portaria de Extinção</span>
                                    <span class="text-[9px] font-bold text-surface-400 dark:text-surface-500 border border-surface-200 dark:border-surface-600 rounded-full px-1.5 py-0.5 uppercase tracking-wide">Opcional</span>
                                </div>
                                <div class="grid grid-cols-2 gap-3">
                                    <div class="flex flex-col gap-1.5">
                                        <label class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Data</label>
                                        <p-inputmask mask="99/99/9999" [(ngModel)]="form.portariaExtincaoData" placeholder="dd/mm/aaaa" [disabled]="estado === 'visualizacao'"></p-inputmask>
                                    </div>
                                    <div class="flex flex-col gap-1.5">
                                        <label class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Número</label>
                                        <input pInputText [(ngModel)]="form.portariaExtincaoNumero" [disabled]="estado === 'visualizacao'" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </app-card-content>

                    <!-- ── Detalhes ── -->
                    <app-card-content [icon]="'pi pi-align-left'" [title]="'Detalhes'" [subtitle]="'Descrição e tipo da comissão'">
                        <div class="doc-detalhes-card flex flex-col gap-5 h-full">
                            <div class="doc-detalhes-conteudo flex flex-col flex-1 gap-4 min-h-0">
                                <div class="doc-descricao-campo flex flex-col gap-1.5 flex-1 min-h-0">
                                    <label class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Descrição</label>
                                    <textarea pTextarea [(ngModel)]="form.descricao" [disabled]="estado === 'visualizacao'" class="resize-none w-full h-full"></textarea>
                                </div>
                                <div class="flex flex-col gap-1.5">
                                    <label class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Tipo</label>
                                    <p-select [options]="tiposComissao" [(ngModel)]="form.tipo" optionLabel="label" optionValue="value" [showClear]="false" appendTo="body" [disabled]="estado === 'visualizacao'" class="w-full" styleClass="w-full" />
                                </div>
                            </div>
                        </div>
                    </app-card-content>
                </div>
            </div>

            <!-- ══════════════════════════════════════════
                 CARD 3 — Equipe
            ══════════════════════════════════════════ -->
            <div class="card-entrada card-entrada-3">
                <app-card-content [icon]="'pi pi-users'" [title]="'Membros e Histórico'" [subtitle]="'Membros, histórico e afastamentos'">
                    <p-button card-header label="Relatório" icon="pi pi-file" size="small"></p-button>
                    <div class="flex flex-col gap-4">
                        <div class="flex justify-start">
                            <p-selectbutton
                                [options]="abasPrincipais"
                                [ngModel]="abaPrincipal"
                                (ngModelChange)="onAbaPrincipalChange($event)"
                                optionLabel="label"
                                optionValue="value"
                                [unselectable]="false"
                                class="flex flex-wrap justify-center gap-2"
                                styleClass="w-44"
                            ></p-selectbutton>
                        </div>

                        @if (abaPrincipal === 'membros') {
                            <div class="flex items-center justify-end gap-3 flex-wrap">
                                <div class="flex items-center gap-2">
                                    @if (estado !== 'visualizacao' && abaComposicao === 'atual') {
                                        <button type="button" pButton label="Adicionar Integrante" icon="pi pi-user-plus" size="small" severity="success" [appCan]="PERMISSOES.comissoes.membros.vincular" (click)="abrirBuscaMembro()"></button>
                                    }
                                </div>
                            </div>

                            <div class="composicao-cards-layout">
                                <section class="composicao-card-coluna">
                                    <div class="composicao-card-coluna-cabecalho">
                                        <div class="min-w-0">
                                            <span class="composicao-card-coluna-titulo">{{ abaComposicao === 'atual' ? 'Composição Atual' : 'Composição Antiga' }}</span>
                                            <span class="composicao-card-coluna-subtitulo">{{ abaComposicao === 'atual' ? 'Integrantes ativos e afastados' : 'Histórico de integrantes' }}</span>
                                        </div>
                                        <span class="composicao-card-contador">{{ membrosExibidos.length }}</span>
                                    </div>

                                    <div class="composicao-card-lista">
                                        @for (item of membrosExibidos; track (item.idSolicitante ?? item.crm ?? item.nome) + item.uf) {
                                            <app-card-container [selected]="isMembroSelecionado(item)" [arrow]="true" (click)="selecionarMembroComposicao(item)" class="composicao-card-membro">
                                                <div class="composicao-card-membro-topo">
                                                    <!-- Foto Column (Always visible) -->
                                                    <div class="composicao-card-foto-coluna">
                                                        <div class="composicao-medico-foto">
                                                            @if (item.avatar) {
                                                                <img [src]="item.avatar" [alt]="item.nome" />
                                                            } @else {
                                                                <span>{{ iniciaisMembro(item.nome) }}</span>
                                                            }
                                                        </div>
                                                    </div>

                                                    <!-- Info Column -->
                                                    <div class="composicao-card-info-coluna">
                                                        <div class="composicao-card-info-cabecalho">
                                                            <div class="composicao-medico-resumo">
                                                                <h3 class="indicador-titulo truncate" [pTooltip]="item.nome">{{ item.nome }}</h3>
                                                                <div class="composicao-medico-tags">
                                                                    <span class="tag-status-membro" [ngClass]="{ 'tag-afastado': item.idStatusMembro === 1, 'tag-ativo': item.idStatusMembro !== 1 }">
                                                                        {{ item.idStatusMembro === 1 ? 'Afastado' : 'Ativo' }}
                                                                    </span>
                                                                    <p-tag [value]="item.dsParticipacao || item.participacao || '-'" [style]="obterEstiloParticipacao(item)" [rounded]="true"></p-tag>
                                                                </div>
                                                            </div>

                                                            <div class="composicao-card-acoes-direita" (click)="$event.stopPropagation()">
                                                                <div class="indicador-contagem">
                                                                    <div class="indicador-valor">{{ item.crm || '-' }}</div>
                                                                    <div class="indicador-label">{{ item.uf || 'UF' }}</div>
                                                                </div>
                                                                <button
                                                                    type="button"
                                                                    pButton
                                                                    [icon]="isMembroExpanded(item) ? 'pi pi-eye-slash' : 'pi pi-eye'"
                                                                    class="p-button-rounded p-button-text p-button-sm !w-8 !h-8 botao-visualizar-membro transition-all duration-300"
                                                                    [class.active]="isMembroExpanded(item)"
                                                                    (click)="toggleExpandMembro($event, item)"
                                                                    [pTooltip]="isMembroExpanded(item) ? 'Recolher' : 'Visualizar'"
                                                                ></button>
                                                            </div>
                                                        </div>

                                                        <div class="composicao-badges-status">
                                                            <span class="composicao-status-badge" [ngClass]="item.assinouLgpd ? 'badge-ok' : 'badge-alerta'">
                                                                <i class="pi" [ngClass]="item.assinouLgpd ? 'pi-shield' : 'pi-shield-exclamation'"></i>
                                                                <span>LGPD: {{ item.assinouLgpd ? 'Assinado' : 'Pendente' }}</span>
                                                            </span>
                                                            <span class="composicao-status-badge" [ngClass]="!item.devedor ? 'badge-ok' : 'badge-alerta'">
                                                                <i class="pi" [ngClass]="!item.devedor ? 'pi-check-circle' : 'pi-exclamation-triangle'"></i>
                                                                <span>Quitação: {{ item.devedor ? 'Devedor' : 'Quite' }}</span>
                                                            </span>
                                                            @if (item.telefones) {
                                                                @for (tel of obterListaTelefones(item.telefones); track tel) {
                                                                    <span class="composicao-telefone-badge cursor-pointer" [pTooltip]="'Clique para copiar: ' + tel" (click)="copiarTelefones(tel); $event.stopPropagation()">
                                                                        <i class="pi pi-phone"></i>
                                                                        <span>{{ tel }}</span>
                                                                    </span>
                                                                    <app-send-whatsapp [text]="gerarMensagemWhatsappMembro(item)" [phone]="tel" [abrirDialog]="true" tooltip="Enviar WhatsApp para este telefone"></app-send-whatsapp>
                                                                }
                                                            } @else {
                                                                <span class="composicao-telefone-badge">
                                                                    <i class="pi pi-phone"></i>
                                                                    <span>Sem telefone</span>
                                                                </span>
                                                            }
                                                            <div class="composicao-contato-acoes" (click)="$event.stopPropagation()">
                                                                <button
                                                                    type="button"
                                                                    pButton
                                                                    icon="pi pi-envelope"
                                                                    class="p-button-rounded p-button-text p-button-sm !w-8 !h-8 botao-copiar-contato transition-all duration-300"
                                                                    [disabled]="!possuiEmails(item.emails)"
                                                                    (click)="copiarEmailsMembro(item.emails, $event)"
                                                                    pTooltip="Copiar todos os e-mails"
                                                                ></button>
                                                                <button
                                                                    type="button"
                                                                    pButton
                                                                    icon="pi pi-phone"
                                                                    class="p-button-rounded p-button-text p-button-sm !w-8 !h-8 botao-copiar-contato transition-all duration-300"
                                                                    [disabled]="!possuiTelefones(item.telefones)"
                                                                    (click)="copiarTelefonesMembro(item.telefones, $event)"
                                                                    pTooltip="Copiar todos os telefones"
                                                                ></button>
                                                            </div>
                                                        </div>

                                                        <!-- Expandable Details -->
                                                        <div class="transition-all duration-500 ease-in-out overflow-hidden" [style.max-height]="isMembroExpanded(item) ? '1000px' : '0'" [style.opacity]="isMembroExpanded(item) ? '1' : '0'">
                                                            <div class="flex flex-col gap-3 pt-3 mt-3">
                                                                <div class="composicao-dados-periodo">
                                                                    <div>
                                                                        <strong>Entrada:</strong><br />
                                                                        {{ item.dtInicio ? formatarDataExibicao(item.dtInicio) : 'N/A' }}
                                                                    </div>
                                                                    <div>
                                                                        <strong>Saída:</strong><br />
                                                                        {{ item.dtFim ? formatarDataExibicao(item.dtFim) : 'N/A' }}
                                                                    </div>
                                                                    <div>
                                                                        <strong>Portaria Entrada:</strong><br />
                                                                        {{ item.nuPortariaInclusao || '-' }}
                                                                    </div>
                                                                    <div>
                                                                        <strong>Portaria Saída:</strong><br />
                                                                        {{ item.nuPortariaRemocao || '-' }}
                                                                    </div>
                                                                </div>

                                                                @if (item.entidadeExterna || item.emails) {
                                                                    <div class="composicao-contato-bloco flex flex-col gap-2">
                                                                        @if (item.entidadeExterna) {
                                                                            <div class="truncate" [pTooltip]="item.entidadeExterna || '-'"><strong>Entidade:</strong> {{ item.entidadeExterna || '-' }}</div>
                                                                        }
                                                                        @if (item.emails) {
                                                                            <div class="flex flex-col gap-1.5">
                                                                                <strong>E-mail:</strong>
                                                                                <div class="flex flex-wrap gap-2">
                                                                                    @for (email of obterListaEmails(item.emails); track email) {
                                                                                        <span class="composicao-email-badge" [pTooltip]="'Clique para copiar: ' + email" (click)="copiarEmails(email); $event.stopPropagation()">
                                                                                            <i class="pi pi-envelope"></i>
                                                                                            <span>{{ email }}</span>
                                                                                        </span>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                }

                                                                @if (estado !== 'visualizacao') {
                                                                    <div class="flex justify-end items-center mt-2 pt-3 border-t border-surface-200 dark:border-surface-700" (click)="$event.stopPropagation()">
                                                                        <div class="flex gap-1">
                                                                            <p-button
                                                                                icon="pi pi-pencil"
                                                                                severity="secondary"
                                                                                [text]="true"
                                                                                [rounded]="true"
                                                                                size="small"
                                                                                [appCan]="PERMISSOES.comissoes.membros.vincular"
                                                                                (onClick)="editarMembroDetalhes(item)"
                                                                                [pTooltip]="'Editar Integrante'"
                                                                            ></p-button>
                                                                            <p-button
                                                                                [icon]="item.idStatusMembro === 1 ? 'pi pi-user' : 'pi pi-calendar-times'"
                                                                                [severity]="item.idStatusMembro === 1 ? 'success' : 'warn'"
                                                                                [text]="true"
                                                                                [rounded]="true"
                                                                                size="small"
                                                                                [appCan]="PERMISSOES.comissoes.membros.afastar"
                                                                                (onClick)="toggleAfastamento(item)"
                                                                                [pTooltip]="item.idStatusMembro === 1 ? 'Reativar Integrante' : 'Afastar Integrante'"
                                                                            ></p-button>
                                                                            <p-button
                                                                                icon="pi pi-trash"
                                                                                severity="danger"
                                                                                [text]="true"
                                                                                [rounded]="true"
                                                                                size="small"
                                                                                [appCan]="PERMISSOES.comissoes.membros.encerrar"
                                                                                (onClick)="removerMembro(item)"
                                                                                [pTooltip]="'Remover Integrante'"
                                                                            ></p-button>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </app-card-container>
                                        } @empty {
                                            <div class="composicao-card-vazio">
                                                <i class="pi pi-inbox"></i>
                                                <span>Nenhum membro encontrado.</span>
                                            </div>
                                        }
                                    </div>

                                    <div class="composicao-switch-rodape">
                                        <div class="custom-subtabs flex gap-1">
                                            @for (aba of abasComposicao; track aba.value) {
                                                <button type="button" class="custom-subtab-item" [class.active]="abaComposicao === aba.value" (click)="selecionarAbaComposicao($any(aba.value))">
                                                    {{ aba.label }}
                                                </button>
                                            }
                                        </div>
                                    </div>
                                </section>

                                <section class="composicao-card-coluna composicao-card-coluna-afastamentos">
                                    <div class="composicao-card-coluna-cabecalho">
                                        <div class="min-w-0">
                                            <span class="composicao-card-coluna-titulo">Afastamentos</span>
                                            <span class="composicao-card-coluna-subtitulo truncate" [pTooltip]="nomeMembroSelecionado">{{ nomeMembroSelecionado }}</span>
                                        </div>
                                        <span class="composicao-card-contador">{{ afastamentosMembro.length }}</span>
                                    </div>

                                    <div class="composicao-card-lista">
                                        @if (carregandoAfastamentos) {
                                            <div class="composicao-card-vazio">
                                                <i class="pi pi-spin pi-spinner"></i>
                                                <span>Carregando afastamentos...</span>
                                            </div>
                                        } @else {
                                            @for (item of afastamentosMembro; track item.inicio + item.termino) {
                                                <app-card-container class="composicao-card-afastamento">
                                                    <div class="indicador-topo">
                                                        <i class="pi pi-calendar-times text-primary"></i>
                                                        <div class="indicador-contagem">
                                                            <div class="indicador-valor">{{ item.inicio }}</div>
                                                            <div class="indicador-label">Início</div>
                                                        </div>
                                                    </div>
                                                    <h3 class="indicador-titulo mt-3">Afastamento</h3>
                                                    <div class="grid grid-cols-2 gap-2 mt-3 text-[10px] text-muted-color border-t border-surface-200 dark:border-surface-700 pt-2">
                                                        <div>
                                                            <strong>Início:</strong><br />
                                                            {{ item.inicio }}
                                                        </div>
                                                        <div>
                                                            <strong>Término:</strong><br />
                                                            {{ item.termino }}
                                                        </div>
                                                    </div>
                                                </app-card-container>
                                            } @empty {
                                                <div class="composicao-card-vazio">
                                                    <i class="pi pi-inbox"></i>
                                                    <span>{{ membroSelecionado ? 'Sem afastamentos registrados.' : 'Selecione um integrante.' }}</span>
                                                </div>
                                            }
                                        }
                                    </div>
                                </section>
                            </div>
                        }
                        @if (abaPrincipal === 'historico') {
                            <app-table-view-switcher [(viewMode)]="currentView"></app-table-view-switcher>

                            @if (currentView() === 'card') {
                                <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
                                    @for (item of historicoCct; track item.data + item.evento + item.usuario) {
                                        <app-card-container>
                                            <div class="indicador-topo">
                                                <i class="pi pi-history text-primary"></i>
                                                <div class="indicador-contagem">
                                                    <div class="indicador-valor">{{ item.data }}</div>
                                                    <div class="indicador-label">Data</div>
                                                </div>
                                            </div>
                                            <h3 class="indicador-titulo mt-3" [pTooltip]="item.evento">{{ item.evento }}</h3>
                                            <div class="mt-3 text-xs border-t border-surface-200 dark:border-surface-700 pt-2">
                                                <span class="text-muted-color">Usuário:</span>
                                                <span class="font-semibold text-surface-700 dark:text-surface-200 ml-1">{{ item.usuario }}</span>
                                            </div>
                                        </app-card-container>
                                    } @empty {
                                        <div class="col-span-full flex flex-col items-center justify-center py-12 text-surface-400">
                                            <i class="pi pi-inbox text-5xl mb-3"></i>
                                            <span>Nenhum histórico encontrado.</span>
                                        </div>
                                    }
                                </div>
                            } @else {
                                <p-table [value]="historicoCct" [tableStyle]="{ 'min-width': '48rem' }" size="small" stripedRows>
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th style="width: 10rem"><strong>Data</strong></th>
                                            <th><strong>Evento</strong></th>
                                            <th style="width: 14rem"><strong>Usuário</strong></th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-item>
                                        <tr>
                                            <td>{{ item.data }}</td>
                                            <td>{{ item.evento }}</td>
                                            <td>{{ item.usuario }}</td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="emptymessage">
                                        <tr>
                                            <td colspan="3" class="text-center py-6">
                                                <i>Nenhum histórico encontrado.</i>
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            }
                        }
                    </div>
                </app-card-content>
            </div>
        </div>

        <!-- ── Rodapé ── -->
        <div class="flex justify-end pt-5 mt-2 border-t border-surface-100 dark:border-surface-700">
            <button type="button" pButton label="Voltar / Cancelar" severity="secondary" [outlined]="true" (click)="cancelarTela()"></button>
        </div>
    </app-card-content>

    <!-- Modal com Wizard de Criação -->
    <p-dialog
        appDialogoPadrao="pi pi-users"
        descricao="Comissão, câmara técnica ou núcleo."
        closeAriaLabel="Fechar"
        header="Nova Comissão"
        [(visible)]="exibirDialogNovo"
        [style]="{ width: '960px', maxWidth: 'calc(100vw - 2rem)', border: 'none' }"
        styleClass="dialogo-nova-comissao"
        appendTo="body"
        (onHide)="fecharDialogNovo()"
    >
        <p-stepper [(value)]="wizardStep" class="wizard-nova-comissao">
            <p-step-list>
                <p-step [value]="1">Identificação</p-step>
                <p-step [value]="2">Portarias</p-step>
                <p-step [value]="3">Integrantes</p-step>
            </p-step-list>

            <p-step-panels>
                <!-- Passo 1: Identificação -->
                <p-step-panel [value]="1">
                    <ng-template #content let-activateCallback="activateCallback">
                        <div class="wiz-info-strip"><i class="pi pi-info-circle"></i><span>Defina a hierarquia organizacional e os dados de identificação da comissão.</span></div>

                        <div class="wiz-corpo wiz-corpo-identificacao">
                            <!-- Estrutura Superior -->
                            <app-card-content [icon]="'pi pi-building'" [title]="'Estrutura Superior'" [subtitle]="'Localização hierárquica'">
                                <div class="wiz-bloco-header">
                                    <span class="wiz-icone wiz-icone-neutra"><i class="pi pi-sitemap"></i></span>
                                    <span class="wiz-titulo">Estrutura Superior</span>
                                </div>
                                <div class="grid grid-cols-12 gap-3">
                                    <div class="col-span-3 wiz-campo">
                                        <span class="wiz-label">Código</span>
                                        <input pInputText readonly [(ngModel)]="form.estruturaSuperiorCodigo" class="w-full" />
                                    </div>
                                    <div class="col-span-9 wiz-campo">
                                        <span class="wiz-label">Estrutura</span>
                                        <div class="flex gap-2">
                                            <input pInputText readonly [(ngModel)]="form.estruturaSuperiorDescricao" class="flex-1" />
                                            <button type="button" class="botao-icone" (click)="abrirBuscaSuperior()">
                                                <i class="pi pi-search"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </app-card-content>

                            <!-- Identificação -->
                            <app-card-content [icon]="'pi pi-id-card'" [title]="'Identificação'" [subtitle]="'Dados básicos da comissão'">
                                <div class="wiz-bloco-header">
                                    <span class="wiz-icone wiz-icone-primaria"><i class="pi pi-id-card"></i></span>
                                    <span class="wiz-titulo">Identificação</span>
                                </div>
                                <div class="grid grid-cols-12 gap-3">
                                    <div class="col-span-3 wiz-campo">
                                        <span class="wiz-label">Código</span>
                                        <input pInputText [(ngModel)]="form.codigo" class="w-full" />
                                    </div>
                                    <div class="col-span-9 wiz-campo">
                                        <span class="wiz-label">Nome <span class="wiz-label-obrigatorio">*</span></span>
                                        <input pInputText [(ngModel)]="form.nome" class="w-full" placeholder="Nome completo da comissão" />
                                    </div>
                                </div>
                            </app-card-content>

                            <!-- Descrição + Tipo -->
                            <div class="wiz-grid-dupla">
                                <app-card-content [icon]="'pi pi-align-left'" [title]="'Descrição'" [subtitle]="'Informações detalhadas'">
                                    <div class="wiz-bloco-header">
                                        <span class="wiz-icone wiz-icone-neutra"><i class="pi pi-align-left"></i></span>
                                        <span class="wiz-titulo">Descrição</span>
                                    </div>
                                    <textarea pTextarea [(ngModel)]="form.descricao" rows="4" class="w-full resize-none"></textarea>
                                </app-card-content>
                                <app-card-content [icon]="'pi pi-tags'" [title]="'Tipo'" [subtitle]="'Classificação da comissão'">
                                    <div class="wiz-bloco-header">
                                        <span class="wiz-icone wiz-icone-neutra"><i class="pi pi-tags"></i></span>
                                        <span class="wiz-titulo">Tipo</span>
                                    </div>
                                    <p-select [options]="tiposComissao" [(ngModel)]="form.tipo" optionLabel="label" optionValue="value" [showClear]="false" appendTo="body" class="w-full" />
                                </app-card-content>
                            </div>
                        </div>

                        <div class="wiz-rodape">
                            <div class="wiz-progresso">
                                <span class="wiz-progresso-dot passo-ativo"></span>
                                <span class="wiz-progresso-dot"></span>
                                <span class="wiz-progresso-dot"></span>
                            </div>
                            <div class="flex gap-2">
                                <button type="button" pButton label="Cancelar" severity="secondary" [outlined]="true" (click)="executarAcao('cancelar')"></button>
                                <p-button label="Próximo" icon="pi pi-arrow-right" iconPos="right" [disabled]="!form.nome.trim()" (onClick)="wizardStep = 2" />
                            </div>
                        </div>
                    </ng-template>
                </p-step-panel>

                <!-- Passo 2: Portarias -->
                <p-step-panel [value]="2">
                    <ng-template #content let-activateCallback="activateCallback">
                        <div class="wiz-info-strip"><i class="pi pi-info-circle"></i><span>Registre os documentos normativos que instituem e, se aplicável, extinguem esta comissão.</span></div>

                        <div class="wiz-corpo wiz-corpo-portarias">
                            <!-- Portaria de Criação -->
                            <app-card-content [icon]="'pi pi-file-check'" [title]="'Portaria de Criação'" [subtitle]="'Documento de instituição'">
                                <div class="wiz-bloco-header">
                                    <span class="wiz-icone wiz-icone-criacao"><i class="pi pi-file"></i></span>
                                    <span class="wiz-titulo">Portaria de Criação</span>
                                </div>
                                <div class="grid grid-cols-2 gap-3">
                                    <div class="wiz-campo">
                                        <span class="wiz-label">Data</span>
                                        <p-inputmask mask="99/99/9999" [(ngModel)]="form.portariaCriacaoData" placeholder="dd/mm/aaaa" styleClass="w-full"></p-inputmask>
                                    </div>
                                    <div class="wiz-campo">
                                        <span class="wiz-label">Número</span>
                                        <input pInputText [(ngModel)]="form.portariaCriacaoNumero" class="w-full" />
                                    </div>
                                </div>
                            </app-card-content>

                            <!-- Portaria de Extinção -->
                            <app-card-content [icon]="'pi pi-file-excel'" [title]="'Portaria de Extinção'" [subtitle]="'Documento de encerramento (opcional)'">
                                <div class="wiz-bloco-header">
                                    <span class="wiz-icone wiz-icone-extincao"><i class="pi pi-file-excel"></i></span>
                                    <span class="wiz-titulo">Portaria de Extinção</span>
                                    <span class="wiz-tag-opcional">Opcional</span>
                                </div>
                                <div class="grid grid-cols-2 gap-3">
                                    <div class="wiz-campo">
                                        <span class="wiz-label">Data</span>
                                        <p-inputmask mask="99/99/9999" [(ngModel)]="form.portariaExtincaoData" placeholder="dd/mm/aaaa" styleClass="w-full"></p-inputmask>
                                    </div>
                                    <div class="wiz-campo">
                                        <span class="wiz-label">Número</span>
                                        <input pInputText [(ngModel)]="form.portariaExtincaoNumero" class="w-full" />
                                    </div>
                                </div>
                            </app-card-content>
                        </div>

                        <div class="wiz-rodape">
                            <div class="wiz-progresso">
                                <span class="wiz-progresso-dot passo-completo"></span>
                                <span class="wiz-progresso-dot passo-ativo"></span>
                                <span class="wiz-progresso-dot"></span>
                            </div>
                            <div class="flex gap-2">
                                <p-button label="Anterior" icon="pi pi-arrow-left" severity="secondary" (onClick)="wizardStep = 1" />
                                <p-button label="Próximo" icon="pi pi-arrow-right" iconPos="right" (onClick)="wizardStep = 3" />
                            </div>
                        </div>
                    </ng-template>
                </p-step-panel>

                <!-- Passo 3: Coordenador e Membros -->
                <p-step-panel [value]="3">
                    <ng-template #content let-activateCallback="activateCallback">
                        <div class="wiz-info-strip"><i class="pi pi-info-circle"></i><span>Defina o coordenador responsável e adicione os membros que compõem a comissão.</span></div>

                        <div class="wiz-corpo wiz-corpo-integrantes">
                            <!-- Coordenador -->
                            <app-card-content [icon]="'pi pi-user'" [title]="'Coordenador'" [subtitle]="'Responsável pela comissão'">
                                <div class="wiz-bloco-header">
                                    <span class="wiz-icone wiz-icone-primaria"><i class="pi pi-user"></i></span>
                                    <span class="wiz-titulo">Coordenador</span>
                                </div>
                                <div class="wiz-campo">
                                    <span class="wiz-label">Coordenador da Comissão</span>
                                    <div class="flex gap-2">
                                        <input pInputText readonly [value]="coordenadorNome ? coordenadorNome + ' (' + coordenadorUf + ')' : ''" placeholder="Sem coordenador definido" class="flex-1" />
                                        <button type="button" class="botao-icone" (click)="abrirBuscaCoordenador()">
                                            <i class="pi pi-search"></i>
                                        </button>
                                    </div>
                                </div>
                            </app-card-content>

                            <!-- Membros -->
                            <app-card-content [icon]="'pi pi-users'" [title]="'Membros'" [subtitle]="'Integrantes da comissão'">
                                <div class="wiz-bloco-header">
                                    <span class="wiz-icone wiz-icone-membros"><i class="pi pi-users"></i></span>
                                    <span class="wiz-titulo">Membros da Comissão</span>
                                    <button type="button" pButton label="Adicionar" icon="pi pi-user-plus" size="small" severity="success" class="ml-auto" [appCan]="PERMISSOES.comissoes.membros.vincular" (click)="abrirBuscaMembro()"></button>
                                </div>

                                <div class="wiz-tabela-membros">
                                    <p-table [value]="membrosExibidos" [tableStyle]="{ 'min-width': '40rem' }" size="small">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th style="width: 4rem" class="text-center">Quite</th>
                                                <th style="width: 3.5rem" class="text-center">LGPD</th>
                                                <th style="width: 3rem">UF</th>
                                                <th style="width: 5rem">CRM</th>
                                                <th>Nome</th>
                                                <th style="width: 10rem">Participação</th>
                                                <th style="width: 8rem">Entrada</th>
                                                <th style="width: 5rem" class="text-right">Ações</th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-item>
                                            <tr>
                                                <td class="text-center">
                                                    <i class="pi" [ngClass]="{ 'pi-check-circle text-green-500': !item.devedor, 'pi-times-circle text-red-500': item.devedor }" [pTooltip]="item.devedor ? 'Devedor' : 'Quite com a tesouraria'"></i>
                                                </td>
                                                <td class="text-center">
                                                    <i
                                                        class="pi"
                                                        [ngClass]="{ 'pi-check-circle text-green-500': item.assinouLgpd, 'pi-times-circle text-red-500': !item.assinouLgpd }"
                                                        [pTooltip]="item.assinouLgpd ? 'Assinou termo LGPD' : 'Não assinou termo LGPD'"
                                                    ></i>
                                                </td>
                                                <td>
                                                    <div class="uf-cell">
                                                        @if (obterBandeiraUf(item.uf); as bandeiraUf) {
                                                            <img [src]="bandeiraUf" [alt]="formatarUf(item.uf)" class="uf-flag" />
                                                        }
                                                        <span>{{ formatarUf(item.uf) }}</span>
                                                    </div>
                                                </td>
                                                <td>{{ item.crm || '-' }}</td>
                                                <td>{{ item.nome }}</td>
                                                <td>
                                                    @if (item.dsParticipacao || item.participacao) {
                                                        <p-tag [value]="item.dsParticipacao || item.participacao" [style]="obterEstiloParticipacao(item)" [rounded]="true"></p-tag>
                                                    } @else {
                                                        -
                                                    }
                                                </td>
                                                <td>{{ item.dtInicio ? formatarDataExibicao(item.dtInicio) : '' }}</td>
                                                <td class="text-right">
                                                    <div class="flex gap-1 justify-end">
                                                        <button
                                                            type="button"
                                                            pButton
                                                            icon="pi pi-pencil"
                                                            severity="secondary"
                                                            [text]="true"
                                                            size="small"
                                                            [appCan]="PERMISSOES.comissoes.membros.vincular"
                                                            (click)="editarMembroDetalhes(item)"
                                                            title="Editar Integrante"
                                                        ></button>
                                                        <button
                                                            type="button"
                                                            pButton
                                                            icon="pi pi-trash"
                                                            severity="danger"
                                                            [text]="true"
                                                            size="small"
                                                            [appCan]="PERMISSOES.comissoes.membros.encerrar"
                                                            (click)="removerMembro(item)"
                                                            title="Remover Integrante"
                                                        ></button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="emptymessage">
                                            <tr>
                                                <td colspan="8" class="wiz-vazio">
                                                    <div class="wiz-vazio-conteudo">
                                                        <i class="pi pi-user-plus"></i>
                                                        <span>Nenhum membro adicionado.</span>
                                                        <small>Use o botão "Adicionar" para incluir integrantes.</small>
                                                    </div>
                                                </td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </app-card-content>
                        </div>

                        <div class="wiz-rodape">
                            <div class="wiz-progresso">
                                <span class="wiz-progresso-dot passo-completo"></span>
                                <span class="wiz-progresso-dot passo-completo"></span>
                                <span class="wiz-progresso-dot passo-ativo"></span>
                            </div>
                            <div class="flex gap-2">
                                <p-button label="Anterior" icon="pi pi-arrow-left" severity="secondary" (onClick)="wizardStep = 2" />
                                <button type="button" pButton label="Cancelar" severity="secondary" [outlined]="true" (click)="fecharDialogNovo()"></button>
                                <p-button label="Confirmar e Salvar" icon="pi pi-save" severity="success" [disabled]="!form.nome.trim()" [appCan]="PERMISSOES.comissoes.cadastro.criar" (onClick)="executarAcao('salvar')" />
                            </div>
                        </div>
                    </ng-template>
                </p-step-panel>
            </p-step-panels>
        </p-stepper>
    </p-dialog>

    <!-- Diálogo Localizar Comissão em árvore -->
    <p-dialog
        appDialogoPadrao="pi pi-users"
        descricao="Busque pela estrutura desejada."
        closeAriaLabel="Fechar"
        header="Localizar Comissão / Câmara Técnica / Núcleo"
        [(visible)]="exibirDialogLocalizar"
        [style]="{ width: '720px', border: 'none' }"
        styleClass="dialogo-atividade-custom dialogo-arvore-comissao-overlay"
        appendTo="body"
    >
        <div class="dialog-arvore-comissao">
            <div class="arvore-painel">
                @if (tiposLocalizarExibicao.length) {
                    <ul class="arvore-lista arvore-tipos">
                        @for (tipo of tiposLocalizarExibicao; track tipo.idTipoComissaoCt) {
                            <li>
                                <div class="arvore-tipo">
                                    <button
                                        type="button"
                                        class="arvore-toggle"
                                        [attr.aria-expanded]="tipoLocalizarExpandido(tipo.idTipoComissaoCt)"
                                        [attr.aria-label]="(tipoLocalizarExpandido(tipo.idTipoComissaoCt) ? 'Recolher ' : 'Expandir ') + tipo.descricao"
                                        (click)="alternarTipoLocalizar(tipo.idTipoComissaoCt)"
                                    >
                                        <i class="pi" [ngClass]="tipoLocalizarExpandido(tipo.idTipoComissaoCt) ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                                    </button>
                                    <i class="pi pi-folder arvore-tipo-icone"></i>
                                    <span>{{ tipo.descricao }}</span>
                                </div>
                                @if (tipoLocalizarExpandido(tipo.idTipoComissaoCt)) {
                                    <ng-container *ngTemplateOutlet="arvoreLocalizarNos; context: { $implicit: tipo.filhos, nivel: 1 }"></ng-container>
                                }
                            </li>
                        }
                    </ul>
                } @else {
                    <div class="arvore-vazia">
                        <i class="pi pi-search"></i>
                        <span>Nenhuma estrutura encontrada.</span>
                    </div>
                }
            </div>

            <div class="arvore-filtros">
                <div class="arvore-filtro-grupo">
                    <span class="arvore-filtro-titulo">Filtrar por</span>
                    <label><input type="radio" name="tipoFiltroLocalizar" value="nome" [(ngModel)]="tipoFiltroLocalizar" (change)="onFiltroLocalizarChange(filtroLocalizar)" /> Nome</label>
                    <label><input type="radio" name="tipoFiltroLocalizar" value="codigo" [(ngModel)]="tipoFiltroLocalizar" (change)="onFiltroLocalizarChange(filtroLocalizar)" /> Código</label>
                </div>

                <div class="arvore-filtro-grupo">
                    <span class="arvore-filtro-titulo">Status</span>
                    <label><input type="radio" name="statusFiltroLocalizar" value="todos" [(ngModel)]="statusFiltroLocalizar" /> Todos</label>
                    <label><input type="radio" name="statusFiltroLocalizar" value="ativas" [(ngModel)]="statusFiltroLocalizar" /> Ativas</label>
                    <label><input type="radio" name="statusFiltroLocalizar" value="extintas" [(ngModel)]="statusFiltroLocalizar" /> Extintas</label>
                </div>

                <div class="arvore-filtro-grupo">
                    <span class="arvore-filtro-titulo">Pesquisa</span>
                    <input
                        pInputText
                        [ngModel]="filtroLocalizar"
                        (ngModelChange)="onFiltroLocalizarChange($event)"
                        [placeholder]="tipoFiltroLocalizar === 'codigo' ? 'Código' : 'Nome'"
                        [attr.aria-label]="tipoFiltroLocalizar === 'codigo' ? 'Pesquisar por código' : 'Pesquisar por nome'"
                        class="w-full"
                    />
                </div>

                <div class="arvore-legenda">
                    <span class="legenda-extinta"></span>
                    <span>Comissões extintas</span>
                </div>
            </div>
        </div>

        <ng-template #arvoreLocalizarNos let-nos let-nivel="nivel">
            <ul class="arvore-lista arvore-nos" [style.--nivel]="nivel">
                @for (no of nos; track no.id) {
                    <li>
                        <div class="arvore-no" [class.selecionado]="noLocalizarSelecionado?.id === no.id" [class.extinta]="no.ativo === 0" (click)="selecionarNoLocalizar(no)">
                            @if (no.filhos.length) {
                                <button
                                    type="button"
                                    class="arvore-toggle"
                                    [attr.aria-expanded]="noLocalizarExpandido(no.id)"
                                    [attr.aria-label]="(noLocalizarExpandido(no.id) ? 'Recolher ' : 'Expandir ') + no.descricao"
                                    (click)="$event.stopPropagation(); alternarNoLocalizar(no.id)"
                                >
                                    <i class="pi" [ngClass]="noLocalizarExpandido(no.id) ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                                </button>
                            } @else {
                                <span class="arvore-toggle-placeholder"></span>
                            }
                            <i class="pi pi-sitemap arvore-no-icone"></i>
                            <span class="arvore-no-codigo">{{ no.id }}</span>
                            <span class="arvore-no-descricao">{{ no.descricao }}</span>
                        </div>
                        @if (no.filhos.length && noLocalizarExpandido(no.id)) {
                            <ng-container *ngTemplateOutlet="arvoreLocalizarNos; context: { $implicit: no.filhos, nivel: nivel + 1 }"></ng-container>
                        }
                    </li>
                }
            </ul>
        </ng-template>

        <ng-template pTemplate="footer">
            <div class="flex justify-end gap-2">
                <button type="button" pButton label="Cancelar" severity="secondary" [outlined]="true" (click)="exibirDialogLocalizar = false"></button>
                <button type="button" pButton label="OK" icon="pi pi-check" [disabled]="!noLocalizarSelecionado" (click)="confirmarLocalizar()"></button>
            </div>
        </ng-template>
    </p-dialog>

    <!-- Diálogo Buscar Participante (Coordenador ou Membro) -->
    <p-dialog
        appDialogoPadrao="pi pi-users"
        descricao="Quem participa da comissão."
        closeAriaLabel="Fechar"
        header="Buscar Participante"
        [(visible)]="exibirDialogParticipante"
        [style]="{ width: '450px', border: 'none' }"
        styleClass="dialogo-atividade-custom"
        appendTo="body"
    >
        <div class="flex flex-col gap-4 py-2 px-1">
            <div class="flex flex-col gap-1.5">
                <div class="flex gap-2">
                    <input pInputText [(ngModel)]="filtroParticipanteNome" placeholder="Buscar por nome" class="flex-1" (keyup.enter)="pesquisarParticipantes()" />
                    <button type="button" class="botao-icone" (click)="pesquisarParticipantes()">
                        <i class="pi pi-search"></i>
                    </button>
                </div>
                <small class="text-muted-color text-xs block pl-0.5">Digite ao menos 3 caracteres para realizar a pesquisa.</small>
            </div>
            @if (carregandoParticipantes) {
                <div class="flex flex-col items-center gap-2 py-6 text-muted-color">
                    <i class="pi pi-spin pi-spinner text-2xl opacity-50"></i>
                    <span class="text-sm font-semibold">Buscando participantes...</span>
                </div>
            } @else {
                <div class="max-h-60 overflow-y-auto border border-surface-200 dark:border-surface-700 rounded-lg">
                    <table class="w-full border-collapse">
                        <thead>
                            <tr class="bg-surface-50 dark:bg-surface-800 text-left border-b border-surface-200 dark:border-surface-700">
                                <th class="p-2 text-xs font-bold text-muted-color uppercase tracking-wide">UF</th>
                                <th class="p-2 text-xs font-bold text-muted-color uppercase tracking-wide">Nome</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (p of participantesPesquisa; track p.idSolicitante) {
                                <tr class="hover:bg-surface-50 dark:hover:bg-surface-800 cursor-pointer border-b border-surface-100 dark:border-surface-800 transition-colors duration-150" (click)="selecionarParticipante(p)">
                                    <td class="p-2 text-sm text-color">{{ p.uf }}</td>
                                    <td class="p-2 text-sm text-color font-semibold">{{ p.nome }}</td>
                                </tr>
                            } @empty {
                                <tr>
                                    <td colspan="2" class="p-6 text-center">
                                        <div class="flex flex-col items-center gap-2 text-muted-color">
                                            <i class="pi pi-users text-2xl opacity-40"></i>
                                            <span class="text-sm font-semibold">Nenhum participante encontrado.</span>
                                        </div>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            }
        </div>
    </p-dialog>

    <!-- Dialogo Buscar Estrutura Superior em arvore -->
    <p-dialog
        appDialogoPadrao="pi pi-building"
        descricao="A qual estrutura esta comissão se subordina."
        closeAriaLabel="Fechar"
        header="Selecionar Estrutura Superior"
        [(visible)]="exibirDialogSuperior"
        [style]="{ width: '720px', border: 'none' }"
        styleClass="dialogo-atividade-custom dialogo-arvore-comissao-overlay"
        appendTo="body"
    >
        <div class="dialog-arvore-comissao">
            <div class="arvore-painel">
                @if (tiposSuperiorExibicao.length) {
                    <ul class="arvore-lista arvore-tipos">
                        @for (tipo of tiposSuperiorExibicao; track tipo.idTipoComissaoCt) {
                            <li>
                                <div class="arvore-tipo">
                                    <button
                                        type="button"
                                        class="arvore-toggle"
                                        [attr.aria-expanded]="tipoSuperiorExpandido(tipo.idTipoComissaoCt)"
                                        [attr.aria-label]="(tipoSuperiorExpandido(tipo.idTipoComissaoCt) ? 'Recolher ' : 'Expandir ') + tipo.descricao"
                                        (click)="alternarTipoSuperior(tipo.idTipoComissaoCt)"
                                    >
                                        <i class="pi" [ngClass]="tipoSuperiorExpandido(tipo.idTipoComissaoCt) ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                                    </button>
                                    <i class="pi pi-folder arvore-tipo-icone"></i>
                                    <span>{{ tipo.descricao }}</span>
                                </div>
                                @if (tipoSuperiorExpandido(tipo.idTipoComissaoCt)) {
                                    <ng-container *ngTemplateOutlet="arvoreSuperiorNos; context: { $implicit: tipo.filhos, nivel: 1 }"></ng-container>
                                }
                            </li>
                        }
                    </ul>
                } @else {
                    <div class="arvore-vazia">
                        <i class="pi pi-sitemap"></i>
                        <span>Nenhuma estrutura encontrada.</span>
                    </div>
                }
            </div>

            <div class="arvore-filtros">
                <div class="arvore-filtro-grupo">
                    <span class="arvore-filtro-titulo">Filtrar por</span>
                    <label><input type="radio" name="tipoFiltroSuperior" value="nome" [(ngModel)]="tipoFiltroSuperior" (change)="onFiltroSuperiorChange(filtroSuperior)" /> Nome</label>
                    <label><input type="radio" name="tipoFiltroSuperior" value="codigo" [(ngModel)]="tipoFiltroSuperior" (change)="onFiltroSuperiorChange(filtroSuperior)" /> Codigo</label>
                </div>

                <div class="arvore-filtro-grupo">
                    <span class="arvore-filtro-titulo">Status</span>
                    <label><input type="radio" name="statusFiltroSuperior" value="todos" [(ngModel)]="statusFiltroSuperior" /> Todos</label>
                    <label><input type="radio" name="statusFiltroSuperior" value="ativas" [(ngModel)]="statusFiltroSuperior" /> Ativas</label>
                    <label><input type="radio" name="statusFiltroSuperior" value="extintas" [(ngModel)]="statusFiltroSuperior" /> Extintas</label>
                </div>

                <div class="arvore-filtro-grupo">
                    <span class="arvore-filtro-titulo">Pesquisa</span>
                    <input pInputText [ngModel]="filtroSuperior" (ngModelChange)="onFiltroSuperiorChange($event)" [placeholder]="tipoFiltroSuperior === 'codigo' ? 'Codigo' : 'Nome'" class="w-full" />
                </div>

                <div class="arvore-legenda">
                    <span class="legenda-extinta"></span>
                    <span>Comissões extintas</span>
                </div>
            </div>
        </div>

        <ng-template #arvoreSuperiorNos let-nos let-nivel="nivel">
            <ul class="arvore-lista arvore-nos" [style.--nivel]="nivel">
                @for (no of nos; track no.id) {
                    <li>
                        <div class="arvore-no" [class.selecionado]="noSuperiorSelecionado?.id === no.id" [class.extinta]="no.ativo === 0" (click)="selecionarNoSuperior(no)">
                            @if (no.filhos.length) {
                                <button
                                    type="button"
                                    class="arvore-toggle"
                                    [attr.aria-expanded]="noSuperiorExpandido(no.id)"
                                    [attr.aria-label]="(noSuperiorExpandido(no.id) ? 'Recolher ' : 'Expandir ') + no.descricao"
                                    (click)="$event.stopPropagation(); alternarNoSuperior(no.id)"
                                >
                                    <i class="pi" [ngClass]="noSuperiorExpandido(no.id) ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                                </button>
                            } @else {
                                <span class="arvore-toggle-placeholder"></span>
                            }
                            <i class="pi pi-sitemap arvore-no-icone"></i>
                            <span class="arvore-no-codigo">{{ no.id }}</span>
                            <span class="arvore-no-descricao">{{ no.descricao }}</span>
                        </div>
                        @if (no.filhos.length && noSuperiorExpandido(no.id)) {
                            <ng-container *ngTemplateOutlet="arvoreSuperiorNos; context: { $implicit: no.filhos, nivel: nivel + 1 }"></ng-container>
                        }
                    </li>
                }
            </ul>
        </ng-template>

        <ng-template pTemplate="footer">
            <div class="flex justify-end gap-2">
                <button type="button" pButton label="Cancelar" severity="secondary" [outlined]="true" (click)="exibirDialogSuperior = false"></button>
                <button type="button" pButton label="OK" icon="pi pi-check" [disabled]="!noSuperiorSelecionado" (click)="confirmarSuperior()"></button>
            </div>
        </ng-template>
    </p-dialog>

    <!-- Diálogo para Detalhes do Membro -->
    <p-dialog
        appDialogoPadrao="pi pi-users"
        descricao="Vínculo do membro com a comissão."
        closeAriaLabel="Fechar"
        header="Detalhes do Membro"
        [(visible)]="exibirDialogMembroDetalhes"
        [style]="{ width: '480px', border: 'none' }"
        styleClass="dialogo-atividade-custom"
        appendTo="body"
    >
        @if (membroEdicao) {
            <div class="flex flex-col gap-4 py-2 px-1">
                <!-- Membro info -->
                <div class="p-3 bg-surface-50 dark:bg-surface-800/50 rounded-lg border border-surface-200 dark:border-surface-700">
                    <span class="text-xs text-muted-color uppercase font-bold tracking-wider">Membro</span>
                    <div class="text-base font-semibold text-color mt-0.5">{{ membroEdicao.nome }}</div>
                    <div class="text-xs text-muted-color mt-0.5">UF: {{ membroEdicao.uf }}</div>
                </div>

                <!-- Participação -->
                <div class="flex flex-col gap-1.5">
                    <span class="text-sm font-semibold text-color">Participação (Cargo)</span>
                    <p-select [options]="participacoesList" [(ngModel)]="membroEdicao.idParticipacao" optionLabel="dsParticipacao" optionValue="id" [showClear]="false" appendTo="body" class="w-full" />
                </div>

                <!-- Portarias lado a lado -->
                <div class="grid grid-cols-2 gap-3">
                    <div class="flex flex-col gap-2 bg-surface-50 dark:bg-surface-800/50 p-3 rounded-lg border border-surface-200 dark:border-surface-700">
                        <span class="text-xs font-bold text-primary flex items-center gap-1.5"> <i class="pi pi-sign-in"></i> Portaria de Entrada </span>
                        <div class="flex flex-col gap-1">
                            <span class="text-xs text-muted-color">Data</span>
                            <p-inputmask mask="99/99/9999" [(ngModel)]="membroEdicao.portariaEntradaData" placeholder="dd/mm/aaaa" styleClass="w-full"></p-inputmask>
                        </div>
                        <div class="flex flex-col gap-1">
                            <span class="text-xs text-muted-color">Número</span>
                            <input pInputText [(ngModel)]="membroEdicao.portariaEntradaNumero" class="w-full" />
                        </div>
                    </div>
                    <div class="flex flex-col gap-2 bg-surface-50 dark:bg-surface-800/50 p-3 rounded-lg border border-surface-200 dark:border-surface-700">
                        <span class="text-xs font-semibold text-muted-color flex items-center gap-1.5"> <i class="pi pi-sign-out"></i> Portaria de Saída <span class="font-normal">(Opcional)</span> </span>
                        <div class="flex flex-col gap-1">
                            <span class="text-xs text-muted-color">Data</span>
                            <p-inputmask mask="99/99/9999" [(ngModel)]="membroEdicao.portariaSaidaData" placeholder="dd/mm/aaaa" styleClass="w-full"></p-inputmask>
                        </div>
                        <div class="flex flex-col gap-1">
                            <span class="text-xs text-muted-color">Número</span>
                            <input pInputText [(ngModel)]="membroEdicao.portariaSaidaNumero" class="w-full" />
                        </div>
                    </div>
                </div>

                <!-- LGPD -->
                <div class="flex items-center gap-2.5 p-3 bg-surface-50 dark:bg-surface-800/50 rounded-lg border border-surface-200 dark:border-surface-700">
                    <input type="checkbox" id="checkLgpd" [(ngModel)]="membroEdicao.assinouLgpd" class="rounded border-surface-300 cursor-pointer" />
                    <label for="checkLgpd" class="text-sm font-semibold cursor-pointer flex items-center gap-2">
                        <i class="pi pi-shield text-primary text-sm"></i>
                        Assinou Termo LGPD
                    </label>
                </div>

                <div class="flex justify-end gap-2 pt-1">
                    <button type="button" pButton label="Cancelar" severity="secondary" [outlined]="true" (click)="exibirDialogMembroDetalhes = false"></button>
                    <p-button label="Confirmar" severity="success" [appCan]="PERMISSOES.comissoes.membros.vincular" (onClick)="confirmarMembroDetalhes()" />
                </div>
            </div>
        }
    </p-dialog>
</section>
